import McqThemes from "./McqThemes";
import AddMcqTheme from "./Add";
import EditMcqTheme from "./Edit";

export const containers = {
  McqThemes,
  AddMcqTheme,
  EditMcqTheme,
};



// WEBPACK FOOTER //
// ./src/modules/admin/mcqThemes/containers/index.js